import { format } from 'date-fns';
import { propOr } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getApp = (state) => state[NAME];

export const getBuildInfo = createSelector(getApp, propOr(null, 'buildInfo'));

export const getKclBeVersion = createSelector(getBuildInfo, propOr('N/A', 'version'));
export const getPkBeVersion = createSelector(getBuildInfo, propOr('N/A', 'gpkVersion'));
export const getBEVersionTimeStamp = createSelector(getBuildInfo, (buildInfo) => {
	return buildInfo.timestamp ? format(new Date(buildInfo.timestamp), 'yyyy-MM-dd HH:mm') : 'N/A';
});
